module.exports = __webpack_public_path__ + "img/icon-drawing.e32ad198.png";